import { render, staticRenderFns } from "./FilePassword.vue?vue&type=template&id=572ceb38"
import script from "./FilePassword.vue?vue&type=script&lang=js"
export * from "./FilePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports